(function ($) {
	$.rentalItem = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			RentalItem = (function ($c, o) {
				var defaults = {
					figure: '.module-element-grid__figure',
					video: '.module-element-grid__video--video',
					data: '.module-element-grid__data',
					dataContainer: '.module-element-grid__data--container',
					dataHeader: '.module-element-grid__data--header',
					dataBody: '.module-element-grid__data--body',
					dataButtons: '.module-element-grid__data--buttons',
					dataBookNow: '.module-element-grid__data--book-now',
					dataBack: '.module-element-grid__data--back',
					dataArrow: '.module-element-grid__data--arrow'
				}; 

				var _o = {},

					v = null, // Vimeo Player

					tli = null, // Timeline In
					tlo = null, // Timeline Out

					$f = null, // Figure
					$v = null, // Vimeo Video
					$d = null, // Data
					$dc = null, // Data Container
					$dh = null, // Data Header
					$db = null, // Data Body
					$dbtn = null, // Data Buttons
					$dbn = null, // Data Book Now
					$dbk = null // Data Back
					$a = null // Arrow
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
					
					
					$f = $(_o.figure, $c);
					$v = $(_o.video, $c);
					$d = $(_o.data, $c);
					$dc = $(_o.dataContainer, $c);
					$dh = $(_o.dataHeader, $c);
					$db = $(_o.dataBody, $c);
					$dbtn = $(_o.dataButtons, $c);
					$dbn = $(_o.dataBookNow, $c);
					$dbk = $(_o.dataBack, $c);
					$a = $(_o.dataArrow, $c);

					v = new Vimeo.Player($v.get(0));

					_BuildTimelineIn();
					_BuildTimelineOut();
					_InitVideo();
				},

					_BuildTimelineIn = function() {
						tli = new TimelineLite({ paused: true });

						var xP = ($c.index() % 2 == 0) ? 100 : -100;

						tli
							.add(new TweenLite($d, .1, { css: { opacity: 1 }, ease: Linear.None}))
							.add(new TweenLite($dbk, .6, { css: { opacity: 1 }, ease: Power4.easeIn }))
							.add(new TweenMax($dbk, .3, { css: { xPercent: xP }, ease: Expo.easeIn }), '-=.5')

							.add(new TweenMax($dh, .3, { css: { x: 0, opacity: 1 }, ease: Expo.easeOut }))
							.add(new TweenMax($db, .3, { css: { x: 0, opacity: 1 }, ease: Expo.easeOut }), '-=.1')
							.add(new TweenMax($dbtn, .3, { css: { y: 0 }, ease: Expo.easeOut }), '-=.1')
							.add(new TweenMax($dbn, .3, { css: { x: 0, opacity: 1 }, ease: Expo.easeOut }), '-=.1')
							.add(new TweenMax($a, .3, { css: { xPercent: -(xP), opacity: 1 }, ease: Expo.easeOut }), '-=.1')
						;
					},

					_BuildTimelineOut = function() {
						tlo = new TimelineLite({ paused: true });

						tlo
							.add(new TweenLite($d, .4, { css: { opacity: 0 }, ease: Power4.easeOut }))
						;
					},

					_InitVideo = function() {
						v.ready().then(function() {
							v.setLoop(true).then(function() {
								v.setCurrentTime(0).then(function() {
									v.pause();
								});
							})
						})
					},

				_BindEvents = function () {
					$c.hover(_OnRollOver, _OnRollOut);

					v.ready().then(function() {
						v.on('timeupdate', _OnVimeoTimeUpdate);
					})
				},

					_OnRollOver = function(e) {
						$c.css('z-index', 10);
						$d.css('pointer-events', 'initial');
						tlo.stop();
						tli.seek(0).play();

						setTimeout(function() {
							v.ready().then(function() {
								v.play();
							});
						}, 1000);
					},

					_OnRollOut = function(e) {
						$c.css('z-index', 1);
						$d.css('pointer-events', 'none');
						tli.stop();
						tlo.play();
						v.pause();
					},

					_OnVimeoTimeUpdate = function() {
						// This is a check to ensure the video doesn't keep playing
						// when the mouse is not over it or the content area.
						if (!($c.is(':hover') || $d.is(':hover'))) {
							v.pause();
						}
					},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.rentalItem = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('rentalItem')) {
				var plugin = new $.rentalItem(this, options);
				$(this).data('rentalItem', plugin);
			}
		});
	};
})(jQuery);
